import {
    HttpResponse,
    DefectStationModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class DefectStationsDataService implements CrudService<DefectStationModel, DefectStationModel> {
    getAll(query: CrudDataQuery<DefectStationModel>): Promise<CrudEnumerableResponse<DefectStationModel>> {
        return ApiService.api.getDefectStationBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<DefectStationModel>): Promise<CrudEnumerableResponse<DefectStationModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<DefectStationModel>> {
        return ApiService.api.getDefectStationById(id, params);
    }

    create(item: DefectStationModel, params?: RequestParams): Promise<CrudResponse<DefectStationModel>> {
        return ApiService.api.insertDefectStation(item, params);
    }

    update(item: DefectStationModel, params?: RequestParams): Promise<DefectStationModel> {
        return ApiService.api.updateDefectStation(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<DefectStationModel> {
        return ApiService.api.patchDefectStation(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<DefectStationModel>): Promise<CrudEnumerableResponse<DefectStationModel>> {
        return ApiService.api.deleteDefectStations(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationDefectStation(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<DefectStationModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: DefectStationModel, params?: RequestParams): Promise<CrudResponse<DefectStationModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getDefectStationGroupped(query, params);
    }

}

